'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../layout/jquery.nice-select.min');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Filter = function () {
  function Filter() {
    var _this = this;

    (0, _classCallCheck3.default)(this, Filter);

    this.products = document.querySelectorAll('[data-filter-item]');
    this.options = document.querySelectorAll('.filter_by input');
    this.fields = document.querySelectorAll('.filter_group p');
    // eslint-disable-next-line no-undef
    this.searchParams = new URLSearchParams(window.location.search);
    document.body.addEventListener('click', function (event) {
      if (event.target.nodeName !== 'INPUT' && !event.target.classList.contains('filter_options') && !event.target.classList.contains('group_toggle')) {
        _this.closeOptions();
      }
    });
  }

  (0, _createClass3.default)(Filter, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.activateFields();
      this.options.forEach(function (el) {
        return el.addEventListener('change', _this2.getActiveOptions.bind(_this2));
      });
      if (this.searchFilterOptions) {
        this.activateFilterBySearchParams();
      }
    }
  }, {
    key: 'getActiveOptions',
    value: function getActiveOptions() {
      var activeOptions = this.activeOptions.map(function (el) {
        return el.value;
      });
      this.urlSearch = activeOptions;
      if (activeOptions.length === 0) {
        this.activateAllProducts();
      } else {
        this.activateCheckedProducts(activeOptions);
      }
    }
  }, {
    key: 'activateAllProducts',
    value: function activateAllProducts() {
      this.products.forEach(function (product) {
        return product.classList.remove('hide');
      });
    }
  }, {
    key: 'activateCheckedProducts',
    value: function activateCheckedProducts(activeOptions) {
      this.products.forEach(function (product) {
        var collections = product.dataset.collections.split('/');
        if (activeOptions.some(function (el) {
          return collections.includes(el);
        })) {
          product.classList.remove('hide');
        } else {
          product.classList.add('hide');
        }
      });
    }
  }, {
    key: 'activateFilterBySearchParams',
    value: function activateFilterBySearchParams() {
      var _this3 = this;

      this.options.forEach(function (el) {
        if (_this3.searchFilterOptions.includes(el.value)) {
          el.checked = true;
        }
      });
      this.getActiveOptions();
    }
  }, {
    key: 'activateFields',
    value: function activateFields() {
      this.fields.forEach(function (el) {
        return el.addEventListener('click', function () {
          return el.classList.toggle('active');
        });
      });
    }
  }, {
    key: 'closeOptions',
    value: function closeOptions() {
      this.fields.forEach(function (el) {
        return el.classList.remove('active');
      });
    }
  }, {
    key: 'urlSearch',
    set: function set(options) {
      this.searchParams.set('filter', options.join(':'));
      window.history.replaceState({}, '', window.location.pathname + '?' + this.searchParams);
    }
  }, {
    key: 'activeOptions',
    get: function get() {
      return [].concat((0, _toConsumableArray3.default)(this.options)).filter(function (el) {
        return el.checked;
      });
    }
  }, {
    key: 'searchFilterOptions',
    get: function get() {
      return this.searchParams.get('filter') ? this.searchParams.get('filter').split(':') : null;
    }
  }]);
  return Filter;
}();

var filter = new Filter();
filter.init();

Shopify.queryParams = {};
if (window.location.search.length) {
  for (var aKeyValue, i = 0, aCouples = window.location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)('#sort-by').bind('change', function () {
    // eslint-disable-next-line camelcase
    Shopify.queryParams.sort_by = (0, _jquery2.default)(this).val();
    window.location.search = _jquery2.default.param(Shopify.queryParams).replace(/\+/g, '%20');
  });
});